import {ActionWithPayload} from '../../helpers/reduxHelpers';
import {DataGroupModel} from '../../models/api/dataGroupModel';

/*
 * Action types.
 */

export enum DataGroupsActionsEnum {
  DATA_UPDATED = '@@data/DATA_UPDATED',
}

/*
 * Types.
 */

interface DataUpdatedActionPayload {
  result: DataGroupModel;
  shouldNotCascade: boolean;
  shouldIgnoreUpdatedAt: boolean;
  isComingFromPusher: boolean;
  isComingFromViewerFetch: boolean;
  requesterId?: number;
}

export interface DataUpdatedAction extends ActionWithPayload<DataUpdatedActionPayload> {
  type: DataGroupsActionsEnum.DATA_UPDATED;
}

/*
 * Action creators.
 */

export interface UpdateDataActionOptions {
  shouldNotCascade?: boolean;
  shouldIgnoreUpdatedAt?: boolean;
  isComingFromPusher?: boolean;
  requesterId?: number;
  isComingFromViewerFetch?: boolean;
}

export function updateDataAction(
  dataGroup: DataGroupModel,
  options: UpdateDataActionOptions = {},
): DataUpdatedAction {
  return {
    type: DataGroupsActionsEnum.DATA_UPDATED,
    payload: {
      result: dataGroup,
      shouldNotCascade: Boolean(options.shouldNotCascade),
      shouldIgnoreUpdatedAt: Boolean(options.shouldIgnoreUpdatedAt),
      isComingFromPusher: Boolean(options.isComingFromPusher),
      requesterId: options.requesterId,
      isComingFromViewerFetch: Boolean(options.isComingFromViewerFetch),
    },
  };
}

/*
 * Union type.
 */

export type DataGroupsAction = DataUpdatedAction;
